import $ from "jquery";
import HelpShiftContentRequester from './HelpShiftRequester';

$(function () {
    const contentRequester = new HelpShiftContentRequester($('.help-system__content-inner'), $('.help-shift-nav'));
    const helpShift = $('.help-shift-categories');

    $('.theme-content .material-parents-path').remove();

    $("html").on('click', ".material-parents-path__item a", function () {
        const categoryId = $(this).data('category-id');
        const url = $(this).attr('href');
        if (typeof categoryId === 'undefined')
            return true;

        contentRequester.requestCategory(categoryId, url);

        helpShift.find('.category-row').removeClass('active-category');
        helpShift.find('.article-row').removeClass('active-article');

        $(`.category-row[data-id="${categoryId}"]`).addClass('active-category');

        return false;
    });
});
